/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SelfServiceDefaultValuesBase {
    getFixupPrototypeFunction() { return SelfServiceDefaultValuesBase.fixupPrototype; }

    static newInstance(model: Partial<SelfServiceDefaultValuesBase>): SelfServiceDefaultValuesBase {
        let obj = Object.assign(new SelfServiceDefaultValuesBase(), model);
        SelfServiceDefaultValuesBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SelfServiceDefaultValuesBase>): SelfServiceDefaultValuesBase {
        if (!model) return null;
        return SelfServiceDefaultValuesBase.newInstance(<SelfServiceDefaultValuesBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SelfServiceDefaultValuesBase) {
        if (!obj) return;

        models.SelfServiceDefaultValuesBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SelfServiceDefaultValuesBase): boolean {
        Object.setPrototypeOf(obj, SelfServiceDefaultValuesBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

}
